import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Autocomplete,
  TextField,
  Button,
  Checkbox,
  Switch,
} from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import {getLocations} from '../utils';
import { updateTransportationAccess } from "redux/actions/addEditWorker";

const IMTransport = ({handleChange}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const workerData = location.state && location.state.worker ? location.state.worker : null;
    const empId = location.state && location.state.empId ? location.state.empId : '';
    const approveForMgr = location.state && location.state.approveForManager
                              ? location.state.approveForManager : {};
    const user = useSelector((state) => state.user.auth.user);  
    const transportationData = useSelector(state => state.addEditWorker.workerRoles.transportation || {});
    const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
    const imtRole = useSelector((state) => state.user.imtRole || null);
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
    const [disableSave, setDisableSave] = useState(true);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [roleOptions, setRoleOptions] = useState(["Supervisor", "Care", "Driver", "RPL"]);
    const [readOnly, setReadOnly] = useState(true);

    useEffect(() => {
      console.log("IMTime Role", imtRole)
      if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
      }
    },[imtRole])

    useEffect(() => {
        if(!districtOptions.length >0){
          getLocations().then(data => {
            const { transportEnabledList=[] } = data;
          //  console.log("transport district list", transportEnabledList)
            setDistrictOptions([...transportEnabledList]);
          });
        }
    }, [])

    useEffect(() => {
        if(transportationData && Object.keys(transportationData).length>0){
          setFormValues(_.cloneDeep(transportationData));
        }
      }, [transportationData])

      useEffect(() => {
        validForm(formValues);
    } ,[formValues])

    const validForm = (formValues) => {
        let errors = {};
        if(formValues?.isActive){
          if(!formValues?.role){
            errors['role'] = "Field is required";
          }
          if(formValues?.districtRestricted  && !formValues?.trDistricts?.length > 0){
            errors['trDistricts'] = "Field is required";
          }
        }
        setFormErrors(errors);
        const isValid = !Object.keys(errors).length > 0 && !_.isEqual(formValues, transportationData);
        setDisableSave(!isValid);
        return isValid;
    }
    
    const handleCloseSnack =  () => {
      setSnackControl(state => ({...state, open:false, message: ""}));
    }

    const handleSubmit = async (e) => {
      e.preventDefault();
      try{
        const isValidForm = validForm(formValues);
        if(!isValidForm){
          throw new Error("Invalid data. Please check!")
        }
        
        const data = {
          actionTS: new Date().toISOString(),
          actionBy: user?.workerId || "",
          role: formValues?.role || "",
          trDistricts: formValues?.trDistricts || [],
          isActive: formValues?.isActive ? true : false,
          activityFamilyId: 'transportation',
          districtRestricted: formValues?.districtRestricted ? true : false
        }
        console.log("transportation submit", formValues, data);
        const response = await dispatch(updateTransportationAccess(data, workerData));
        if(response && response.status){
          setSnackControl({
            open: true,
            message: "Transportation Access updated successfully.",
            severity: 'success'
          })
        }else{
          setSnackControl({
            open: true,
            message: "Transportation Access update failed.",
            severity: 'error'
          })
        }
  
  
      }catch(error){
        console.log("transportation handleSumit error", error);
        setSnackControl({
          open: true,
          message: "transportation Access failed to submit.",
          severity: "error"
        })
      }
    }

  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
          <Card sx={{ overflow: "auto", width:"100%", height:'calc(100vh - 160px)'}}>
          {loadingRoles ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                IM Transport
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container rowSpacing={3} marginTop={2} paddingLeft={3}>
                  <Grid
                    container
                    columnSpacing={3}
                    marginBottom={3}
                    alignItems="center"
                  >
                    <Grid item xs={2}  md={2} lg ={0.7}>
                      <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Switch 
                        id = "isActive"
                        name="isActive"
                        inputProps={{ 'aria-label': 'Enable transportation Role switch' }}
                        checked={formValues?.isActive}
                        onChange={(e) => {
                          let checked = e.target.checked;
                          setFormValues({ ...formValues, isActive: checked });
                        }}
                        disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={3}>
                      <Checkbox
                        checked={formValues?.districtRestricted ? true : false}
                        name="districtRestricted"
                        id="districtRestricted"
                        inputProps={{
                          "aria-label": "controlled",
                          shrink: true,
                        }}
                        onChange={e => {
                          const checked = e.target.checked;
                          if(readOnly){
                            return
                          }
                          else{
                            setFormValues(prevState => ({...prevState, districtRestricted: checked}))
                          }
                        }}
                        disabled = {!formValues?.isActive || readOnly}
                      />
                      District Restricted
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5} spacing={3} marginTop={3}>
                    <Grid item xs={12} md={6} lg={3}>
                      <Autocomplete
                        renderInput={(params) => (
                          <TextField
                           {...params} 
                           label="Select District" 
                           required 
                           error= {formErrors?.trDistricts}
                           helperText= {formErrors?.trDistricts}
                           />
                        )}
                        id="trDistricts"
                        name="trDistricts"
                        size="small"
                        multiple
                        options={districtOptions || []}
                        value={formValues?.trDistricts || []}
                        disableCloseOnSelect
                        onChange={(e,v) => {
                          setFormValues(prevState => ({...prevState, trDistricts: v? v : []}))
                        }}
                        disabled= {!formValues?.districtRestricted || readOnly}
                        readOnly={readOnly}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <Autocomplete
                        renderInput={(params) => (
                          <TextField {...params} 
                            label="Select Role" 
                            required
                            error= {formErrors?.role}
                            helperText= {formErrors?.role}
                            />
                        )}
                        id="role"
                        name="role"
                        size="small"
                        options={roleOptions || []}
                        value={formValues?.role || ""}
                        onChange={(e,v) => {
                          setFormValues(prevState => ({...prevState, role: v ? v : ""}))
                        }}
                        readOnly={readOnly}
                        disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={8}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={(e) => handleChange(e, 0)}
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginRight: 30, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled= {disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};

export default IMTransport;
